export default __webpack_public_path__ + "static/media/kurian sibi.dcf93ffd.jpg";